import { ref, onMounted, onUnmounted } from 'vue'

const REDUCED_MOTION_MEDIA = '(prefers-reduced-motion: reduce)'

/**
 * Returns a ref that is true when the user prefers reduced motion.
 * Use it to skip or shorten animations (e.g. pass duration: 0 to motion).
 * @returns { import('vue').Ref<boolean> }
 */
export function useReducedMotion() {
  const reduced = ref(false)
  let mediaQuery = null

  function update() {
    reduced.value = mediaQuery?.matches ?? false
  }

  onMounted(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    mediaQuery = window.matchMedia(REDUCED_MOTION_MEDIA)
    update()
    mediaQuery.addEventListener('change', update)
  })

  onUnmounted(() => {
    mediaQuery?.removeEventListener('change', update)
  })

  return reduced
}
